import { useAuth } from '@/hooks';
import { useNavigate } from 'react-router-dom';

import CustomInput from '@/components/CustomInput';
import { ILoginResponse, IUser } from '@/interfaces/authInterface';
import {
  Box,
  Button,
  Link,
  colors as muiColors,
  Typography,
} from '@mui/material';
import Grid2 from '@mui/material/Grid2';

import { contactUs, somethingWentWrongMessage } from '@/constants/constants';
import { setStoredToken } from '@/helpers/localStorageToken';
import { colors } from '@/theme';
import { useState } from 'react';
import { LoginFormHeroSection } from '../login_form';
import {
  loginButtonStyle,
  loginContainerSize,
  loginContainerStyle,
} from '../style';

export const SignInForm = () => {
  const navigate = useNavigate();
  const auth = useAuth();

  const [userCredentials, setUserCredentials] = useState<IUser>({
    username: '',
    password: '',
  });

  const [errorOnLogin, setErrorOnLogin] = useState<string>('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUserCredentials(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    auth.signIn(userCredentials, (resp: ILoginResponse) => {
      if (resp.token) {
        setStoredToken(resp.token);
        navigate('/portal', { replace: true });
      } else {
        setErrorOnLogin(resp.error);
      }
    });
  };

  return (
    <Grid2 size={loginContainerSize} sx={loginContainerStyle}>
      <Box px={2} py={1}>
        <LoginFormHeroSection />
        <form onSubmit={handleSubmit}>
          <CustomInput
            name="username"
            value={userCredentials.username}
            handleChange={handleChange}
            label="Username"
            placeholder="Enter your username..."
            isIconActive={false}
            required={true}
            type="text"
            className=""
            labelClass="username"
          />
          <CustomInput
            name="password"
            label="Password"
            value={userCredentials.password}
            handleChange={handleChange}
            placeholder="Enter your password..."
            isIconActive={true}
            required={true}
            type="password"
            className=""
          />
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            mt={2}
            width="100%"
            color={colors.black}
          ></Box>
          {errorOnLogin && (
            <>
              <Typography variant="body1" color={colors.error} mt={0}>
                {errorOnLogin}
              </Typography>
              {errorOnLogin === somethingWentWrongMessage && (
                <Typography variant="body1" color={muiColors.green[500]} pt={0}>
                  {contactUs}
                  <Link
                    href="mailto:support@scribebrain.ai"
                    color={muiColors.green[500]}
                  >
                    support@scribebrain.ai
                  </Link>
                </Typography>
              )}
            </>
          )}
          <Button
            variant="contained"
            type="submit"
            fullWidth
            sx={loginButtonStyle}
          >
            Log In
          </Button>
        </form>
      </Box>
    </Grid2>
  );
};
